import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  LotWizardStep,
  OrgWizardStep1,
  OrgWizardStep2,
  LandmarkStep,
  PersonWizardStep1,
  PersonWizardStep2,
  PersonWizardStep3,
  PersonWizardStep4
} from '../index';
import {
  updateEditData
} from '../../actions/wizard.action';
import {
  createOrganization,
  updateOrganization,
  createOrgRelations,
  getOrganizations,
  getLandmarks
} from '../../actions/organizations.action';
import {
  createNewUser,
  updateUser
} from '../../actions/users.action';
import {
  updateLot
} from '../../actions/lots.action';
import StepWizard from 'react-step-wizard';
import './Wizard.scss';
import { addToast } from '../../actions/toast.action';
import { sendRegistrationEmail } from '../../actions/registrationEmail.action';
import { initRecursiveTree, setFullTree } from '../../actions/wizard.action';
import { updateOrgRelationships } from '../../actions/relationships.action';
import { clearSearchTerm } from '../../actions/filter.action';
import _ from 'lodash';

const forwardRef = React.createRef();
class Wizard extends Component {
  updateEditData = (data) => {
    const edits = Object.assign({}, this.props.data, this.props.editData, data);
    this.props.updateEditData(edits);
  }

  addNewToast = (text, action = 'dismiss', autohide = true, autohideTimeout = 5000) => {
    const toasts = this.props.toastList && this.props.toastList.slice();
    toasts.push({ text, action });

    this.props.addToast({ toasts, autohide, autohideTimeout });
  };

  confirmPersonWizard = (edited, data, send) => {
    this.props.clearSearchTerm();
    return edited ? this.props.updateUser(data) : this.props.createNewUser(data.edits, send);
  }

  scrollToTop = () => {
    forwardRef.current.scrollIntoView();
  }

  confirmOrgWizard = async(returningOrg, newOrgData, returningOrgData) => {
    try {
      this.props.clearSearchTerm();
      if (returningOrg) {
        this.props.updateOrgRelationships(returningOrgData);
      } else if (newOrgData.autoCompleteKey) {
        this.props.createOrgRelations(newOrgData);
      } else {
        this.props.createOrganization(newOrgData);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  confirmLotWizard = (data) => {
    this.props.clearSearchTerm();
    this.props.updateLot(data);
  }

  render() {
    const { title, data, hide, relationships, getLandmarks } = this.props;

    const wizardActions = {
      update: this.updateEditData,
      confirmOrg: this.confirmOrgWizard,
      confirmPerson: this.confirmPersonWizard,
      confirmLot: this.confirmLotWizard,
      addToast: this.addNewToast,
      sendEmail: this.props.sendRegistrationEmail,
      initRecursiveTree: this.props.initRecursiveTree,
      sendRegistrationEmail: this.props.sendRegistrationEmail,
      getOrganizations: this.props.getOrganizations,
      buildTree: this.props.buildTree,
      setFullTree: this.props.setFullTree,
      getLandmarks,
      clearSearchTerm: this.props.clearSearchTerm
    };

    const titleToDialogTitle = {
      'People': 'User',
      'Organizations': 'Organization',
      'Lots/Garages': 'Lot/Garage'
    };

    const viewerOption = () => {
      const arr = relationships.map((x) => { return { value: x.childKey, label: x.childName }; });
      arr.splice(0, 0, { value: 'b88a59a0-4f34-4e46-beeb-f0ff57e46892', label: 'ParkHub' });
      return _.uniqBy(arr, 'value');
    };

    const options = {
      roleOptions: [{ value: 'OPERATOR', label: 'Operator' }, { value: 'VIEWER', label: 'Viewer' }],
      relationshipOptions: [
        { value: 'CLIENT', label: 'client' },
        { value: 'IN_HOUSE_STAFF', label: 'in house staff ' },
        { value: 'CITY_IN_HOUSE_STAFF', label: 'city in house staff ' },
        { value: 'CONTRACTED_STAFF', label: 'contracted staff' },
        { value: 'CONTRACTOR', label: 'contractor' }
      ],
      parkhubOptions: [{ value: 'CLIENT', label: 'client' }],
      orgOptions: viewerOption(),
      userOrgOptions: {
        'OPERATOR': _.uniqBy(relationships.map((x) => { return { value: x.childKey, label: x.childName, type: x.relationshipType }; })
          .filter(x => x.type === 'CITY_IN_HOUSE_STAFF' ||
          x.type === 'CITY_CONTRACTED_STAFF' ||
          x.type === 'IN_HOUSE_STAFF' ||
          x.type === 'CONTRACTED_STAFF'
          ), 'value'),
        'VIEWER': viewerOption()
      },
      lotOperatorOptions: _.uniqBy(relationships.map((x) => { return { value: x.childKey, label: x.childName, type: x.relationshipType }; })
        .filter(x => x.type === 'CITY_IN_HOUSE_STAFF' ||
        x.type === 'CITY_CONTRACTED_STAFF' ||
        x.type === 'IN_HOUSE_STAFF' ||
        x.type === 'CONTRACTED_STAFF'
        ), 'value')
    };

    this.checkIfVenueTeam = (data) => {
      if (data &&
        data.multiOrgs &&
        !data.autoCompleteKey &&
        data.multiOrgs.filter(rel => rel.relationshipType.value === 'IN_HOUSE_STAFF' || rel.relationshipType.value === 'CONTRACTED_STAFF').length > 0) {
        return true;
      } else {
        return false;
      }
    };

    const wizardSelect = {
      'People': [
        <PersonWizardStep1 key={0} hide={hide} title={titleToDialogTitle[title]} actions={wizardActions} data={data} relationships={relationships} />,
        <PersonWizardStep2 key={1} title={titleToDialogTitle[title]} actions={wizardActions} data={data} />,
        <PersonWizardStep3
          key={2}
          ref={forwardRef}
          options={options}
          title={titleToDialogTitle[title]}
          actions={wizardActions}
          data={data}
          editData={this.props.editData}
          hide={hide}
          err={this.props.peopleError}
        />,
        <PersonWizardStep4
          key={3}
          options={options}
          title={titleToDialogTitle[title]}
          actions={wizardActions}
          data={data}
          editData={this.props.editData}
          hide={hide}
          err={this.props.peopleError}
          sendRegistrationEmail={this.props.sendRegistrationEmail}
          registrationTreeBranches={this.props.registrationTreeBranches}
          readyBuildState={this.props.readyBuildState}
          fullTree={this.props.fullTree}
          scrollToTop={this.scrollToTop}
        />
      ],
      'Organizations': [
        <OrgWizardStep1
          key={0}
          options={options}
          relationships={relationships}
          orgList={this.props.orgList.filter(x => x.externalKey !== 'b88a59a0-4f34-4e46-beeb-f0ff57e46892')}
          hide={hide}
          title={titleToDialogTitle[title]}
          actions={wizardActions}
          data={data}
        />,
        <OrgWizardStep2
          key={1}
          options={options}
          title={titleToDialogTitle[title]}
          actions={wizardActions}
          data={data}
          editData={this.props.editData}
          hide={hide}
          checkIfVenueTeam={this.checkIfVenueTeam}
        />,
        <LandmarkStep
          key={2}
          options={options}
          title={titleToDialogTitle[title]}
          actions={wizardActions}
          data={data}
          editData={this.props.editData}
          hide={hide}
          orgList={this.props.orgList}
          organizations={this.props.organizations}
          landmarks={this.props.landmarks}
        />
      ],
      'Lots/Garages': [
        <LotWizardStep
          key={0}
          options={options}
          title={titleToDialogTitle[title]}
          actions={wizardActions}
          data={data}
          hide={hide}
          editData={this.props.editData}
          relationships={relationships}
        />
      ],
      'sendEmail': [
        <PersonWizardStep4
          key={3}
          options={options}
          title={titleToDialogTitle['People']}
          actions={wizardActions}
          data={data}
          editData={this.props.editData}
          hide={hide}
          err={this.props.peopleError}
          registrationTreeBranches={this.props.registrationTreeBranches}
          readyBuildState={this.props.readyBuildState}
          fullTree={this.props.fullTree}
          scrollToTop={this.scrollToTop}
        />
      ]
    };

    return (
      <StepWizard id="wizard" children={wizardSelect[title]} />
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.wizard.data,
  editData: state.wizard.editData,
  relationships: state.organizations.relationships,
  landmarks: state.organizations.landmarks,
  orgList: state.organizations.data,
  toastList: state.toast.toasts,
  autoHideToast: state.toast.autohide,
  lotError: state.lots.isError,
  orgError: state.organizations.isError,
  peopleError: state.users.isError,
  registrationTreeBranches: state.wizard.registrationTreeBranches,
  readyBuildState: state.wizard.readyBuildState,
  fullTree: state.wizard.fullTree
});

export default withRouter(connect(mapStateToProps, {
  updateEditData,
  addToast,
  createOrganization,
  updateOrganization,
  updateOrgRelationships,
  createNewUser,
  updateUser,
  updateLot,
  sendRegistrationEmail,
  createOrgRelations,
  initRecursiveTree,
  getOrganizations,
  getLandmarks,
  clearSearchTerm,
  setFullTree
})(Wizard));



// WEBPACK FOOTER //
// ./src/components/Wizard/Wizard.jsx